import React from 'react';
import { Network } from 'lucide-react';
import { RelationshipGraph } from '../components/RelationshipGraph';

export const RelationshipNetworkLab: React.FC = () => {
  return (
    <div className="space-y-6">
      <div className="text-center space-y-2">
        <div className="flex items-center justify-center gap-3">
          <Network className="h-8 w-8 text-consulting-slate-blue-600" />
          <h1 className="text-3xl font-bold text-charcoal-900">Relationship Network (Lab)</h1>
        </div>
        <p className="text-charcoal-600 text-sm">Experimental relationship visualization moved from M2 for iteration.</p>
      </div>

      <div className="bg-[var(--bg-raised)] border border-charcoal-200 p-4">
        <RelationshipGraph />
      </div>
    </div>
  );
};


